module.exports = ".background-nofound {\n  min-height: 200px !important; }\n\n.background-nofound .content {\n  margin-top: 0px !important; }\n"